import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useModal } from '_hooks/useModal';
import ItemDetail from './components/ItemDetail';
import ButtonItemAction from './components/ButtonItemAction';
import { useItemDetail } from './hooks';
import ModalFromProduct from '../../../CreateItem/components/ModalFromProduct';

const CreateEventStep2 = () => {
  const {
    items,
    handleAddItem,
    handleDeleteItem,
    handleDuplicateItem,
    handleMoveUp,
    handleMoveDown,
    handleAddItemsFromCatalogue,
  } = useItemDetail();

  const { formState: { errors }, watch } = useFormContext() || { formState: { errors: {} } };
  const groupId = watch ? watch('groupId')?.value : undefined;

  const catalogueModal = useModal();

  return (
    <div className="event-hosting-step-container">
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        {typeof errors?.items?.message === 'string' && (
          <div style={{ color: '#E24B4A', fontSize: '12px', marginBottom: '10px', fontWeight: 600 }}>
            {errors.items.message}
          </div>
        )}
        {items.map((item, index) => (
          <ItemDetail
            key={item.id || index}
            itemNumber={index + 1}
            onMoveUp={() => handleMoveUp(index)}
            onMoveDown={() => handleMoveDown(index)}
            onDuplicate={() => handleDuplicateItem(index)}
            onDelete={() => handleDeleteItem(index)}
          />
        ))}
        <ButtonItemAction
          onAddItem={handleAddItem}
          onAddFromCatalogue={catalogueModal.openModal}
        />
      </div>

      <ModalFromProduct
        isOpen={catalogueModal.isOpen}
        toggle={catalogueModal.toggleModal}
        closeModal={catalogueModal.closeModal}
        onAdd={handleAddItemsFromCatalogue}
        groupId={groupId}
      />
    </div>
  );
};

export default CreateEventStep2;
